<div>
    <mat-card class="no-shadow" style="max-width: 600px;">
        @if (title != '' || subtitle != '') {
        <mat-card-header>
            <div class="avatar-modal-confirm" mat-card-avatar>
                <mat-icon color="white">info</mat-icon>
            </div>
            <mat-card-title>{{title}}</mat-card-title>
            <mat-card-subtitle *ngIf="subtitle != ''">{{subtitle}}</mat-card-subtitle>
        </mat-card-header>
        }
        <mat-card-content *ngIf="message != ''">
            @if (title != '' || subtitle != '') {
            <mat-divider></mat-divider>
            }
            <div class="pt-1 text-center">
                <h2 class="mt-0">{{message}}</h2>
            </div>
        </mat-card-content>
        <mat-card-actions>
            <mat-divider></mat-divider>
            <div class="pt-1 w-100 fx-row fx-align-space-between-center">
                <div class="fx-column fx-align-start-start">
                    <button class="btn active" mat-button data-testid="modal-confirm-no-button" [attr.aria-label]="button_no" (click)="emitAction(false)">{{button_no}}</button>
                </div>
                <div class="fx-column fx-align-end-start">
                    <button class="btn active" mat-flat-button color="primary" [attr.aria-label]="button_yes" (click)="emitAction(true)">{{button_yes}}</button>
                </div>
            </div>
        </mat-card-actions>
    </mat-card>
</div>